<div mat-dialog-content fxLayout="column" fxLayoutAlign="start">
    <div class="posting-container">
        <mat-icon class="close-dialog" (click)="dialogRef.close(false)">close</mat-icon>
        <div class="layer"></div>
        <div class="posting-image" *ngIf="posting.image" [style.background-image]="'url(' + posting.image.url + ')'"></div>
        <div class="posting-title">
            <mat-chip-set class="mb-4" tabIndex="-1" *ngIf="posting.postingType.displayNameKeySingular">
                <mat-chip class="accent-500" [disableRipple]="true">{{ posting.postingType.displayNameKeySingular | translate }}</mat-chip>
            </mat-chip-set>
            <h2 tabIndex="0">{{ posting.translation.title }}</h2>
        </div>
    </div>
    <div class="posting-content p-16 p-sm-40">
        <p [innerHTML]="posting.translation.description | safeHtml"></p>
    </div>
</div>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center" class="pt-24 mb-0 action-buttons" *ngIf="posting.url">
    <app-flat-button [label]="posting.postingType.actionButtonTextKey" (onClick)="openPostingUrl()"></app-flat-button>
</div>
